import React, { useRef } from "react";
import "./salesView.css";

const SalesViewModal = ({ sale, onClose }) => {
  const printRef = useRef();

  if (!sale) return null;

  const subtotal = sale.items.reduce(
    (sum, item) => sum + item.quantity * item.price,
    0
  );

  // createdBy is populated from backend as { name, role, jobTitle }
  const seller = sale.createdBy;
  const sellerName = seller?.name || null;
  const sellerRole = seller?.role
    ? seller.role.charAt(0).toUpperCase() + seller.role.slice(1)
    : null;
  const sellerTitle = seller?.jobTitle || null;

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-card" ref={printRef}>
        <div id="sale-printable">
          <div className="bill-header">
            <h3>Receipt</h3>
            <p className="bill-id">#{sale._id.slice(-8).toUpperCase()}</p>
          </div>

          <div className="bill-meta">
            <p><b>Customer:</b> {sale.walkInCustomer || "Walk-in"}</p>
            <p><b>Payment:</b> {sale.paymentType.toUpperCase()}</p>
            <p><b>Date:</b> {new Date(sale.createdAt).toLocaleString("en-IN")}</p>
            {sellerName && (
              <p>
                <b>Served by:</b> {sellerName}
                {sellerRole && <span className="seller-role-badge"> · {sellerTitle || sellerRole}</span>}
              </p>
            )}
          </div>

          <hr />

          <table className="print-table">
            <thead>
              <tr className="bill-table">
                <th style={{ textAlign: "left" }}>Product</th>
                <th style={{ textAlign: "center" }}>Qty</th>
                <th style={{ textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {sale.items.map((item, index) => (
                <tr key={index}>
                  <td>{item.product?.itemName || item.product}</td>
                  <td style={{ textAlign: "center" }}>{item.quantity}</td>
                  <td style={{ textAlign: "right" }}>₹{(item.quantity * item.price).toLocaleString("en-IN")}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <hr />

          <div className="bill-summary">
            <p><span>Subtotal:</span> <span>₹{subtotal.toLocaleString("en-IN")}</span></p>
            <p><span>Discount:</span> <span>— ₹{(sale.discount || 0).toLocaleString("en-IN")}</span></p>
            <p className="grand-total"><span>Grand Total:</span> <span>₹{sale.total.toLocaleString("en-IN")}</span></p>
          </div>

          {sellerName && (
            <p className="bill-footer-seller">
              Thank you! Served by <b>{sellerName}</b>{sellerRole ? ` (${sellerTitle || sellerRole})` : ""}
            </p>
          )}
        </div>

        <div className="modal-buttons">
          <button className="close-btn" onClick={onClose}>Close</button>
          <button className="print-btn" onClick={handlePrint}>🖨 Print</button>
        </div>
      </div>
    </div>
  );
};

export default SalesViewModal;
